// src/vocabulary/B1/unit3/content.js

const content = {
  level: "B1",
  unit: 3,
  title: "Describing People (Appearance)",
  description:
    "Words used to describe how people look. Learn how to talk about height, hair, and general appearance.",

  explanation: [
    "This unit focuses on describing how people look.",
    "You will learn words related to height, hair, and general appearance.",
    "These words are often used with the verb 'to be'.",
    "For example: He is tall. She has long hair.",
    "You can also combine words to give more detail.",
    "For example: He is tall with short hair.",
    "Describing appearance is common when talking about friends or family.",
    "Try to describe someone you know using these words."
  ],

  items: [
    {
      word: "tall",
      phonetic: "/tɔːl/",
      meaning: "طويل",
      example: "He is tall and thin."
    },
    {
      word: "short",
      phonetic: "/ʃɔːrt/",
      meaning: "قصير",
      example: "She is short."
    },
    {
      word: "thin",
      phonetic: "/θɪn/",
      meaning: "نحيف",
      example: "The man is thin."
    },
    {
      word: "fat",
      phonetic: "/fæt/",
      meaning: "سمين",
      example: "He is fat."
    },
    {
      word: "long hair",
      phonetic: "/lɒŋ heər/",
      meaning: "شعر طويل",
      example: "She has long hair."
    },
    {
      word: "short hair",
      phonetic: "/ʃɔːrt heər/",
      meaning: "شعر قصير",
      example: "He has short hair."
    }
  ]
};

export default content;


